import styled, { css } from 'styled-components'

import { Colors, mediaQueries } from '@fourthwall/components'

export const IdleContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ListContainer = styled.div<{ $scrollable?: boolean }>`
  flex: 1;
  overflow: auto;
  overflow-x: hidden;
  height: 100%;

  ${({ $scrollable }) =>
    !$scrollable &&
    css`
      overflow: hidden;
    `}

  /* NOTE: Hack for making checkbox focus outline visible */
  padding-left: 20px;
  margin-left: -20px;

  padding-right: 20px;
  margin-right: -20px;

  ${mediaQueries.tablet} {
    height: 457px;
    padding-right: 16px;
    margin-right: 0;
  }
`

export const Bar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  height: 80px;
  padding: 0 32px;
  border-top: 1px solid ${Colors.GS400};
  background-color: ${Colors.GS100};
`

export const Message = styled.div`
  margin-right: auto;

  color: ${Colors.GS600};
`

export const LoaderWrapper = styled.div`
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;

  ${mediaQueries.tablet} {
    height: 96px;
  }
`
